
/// <reference path="../membershipManager.module.ts" />
module Meevo.Plugins.MembershipManager {

    class BillHistoryModalController {

        static $inject = [
            "$filter",
            "$mdDialog",
            "$translate",
            'modalTitle',
            'modalDate',
            'nextAttemptDate',
            'billHistory',
            'isSingleLocation'
        ];

        constructor(
            protected $filter: angular.IFilterService,
            protected $mdDialog: angular.material.IDialogService,
            protected $translate: angular.translate.ITranslateService,
            public modalTitle: string,
            public modalDate: Date,
            public nextAttemptDate: Date,
            public billHistory: any,
            public isSingleLocation: boolean
        ) {
            
        }

        public paymentType = Meevo.Model.PaymentAccountTypeEnum;

        apply = () => {
            this.$mdDialog.hide(true);
        };

        cancel = () => {
            this.$mdDialog.hide(false);
        };
    }

    angular.module("meevo.plugins.membershipManager")
        .controller("meevo.plugins.membershipManager.BillHistoryModalController", BillHistoryModalController);
}